import React from 'react';
import type { CatalogItem } from '../../services/restaurantService';
import './Catalog.css';

function catalogLabel(item: CatalogItem): string {
  return item.name || item.type || '';
}

function catalogInitial(item: CatalogItem): string {
  const label = catalogLabel(item);
  return label ? label.charAt(0).toUpperCase() : '?';
}

interface CatalogIconRailProps {
  items: CatalogItem[];
  selectedId: number | null;
  onSelect: (id: number | null) => void;
  allLabel?: string;
}

const CatalogIconRail: React.FC<CatalogIconRailProps> = ({
  items,
  selectedId,
  onSelect,
  allLabel = 'All',
}) => {
  return (
    <nav className="catalog-icon-rail" aria-label="Categories">
      <button
        type="button"
        className={`catalog-rail-item${selectedId === null ? ' catalog-rail-item--active' : ''}`}
        onClick={() => onSelect(null)}
      >
        <span className="catalog-rail-item__icon catalog-rail-item__icon--all" aria-hidden>
          ☰
        </span>
        <span className="catalog-rail-item__label">{allLabel}</span>
      </button>
      {items.map((item) => {
        const label = catalogLabel(item);
        const active = selectedId === item.id;
        return (
          <button
            key={item.id}
            type="button"
            className={`catalog-rail-item${active ? ' catalog-rail-item--active' : ''}`}
            onClick={() => onSelect(item.id)}
            aria-current={active ? 'true' : undefined}
          >
            {item.iconUrl ? (
              <img src={item.iconUrl} alt="" className="catalog-rail-item__icon-img" />
            ) : (
              <span className="catalog-rail-item__icon catalog-rail-item__icon--fallback">
                {catalogInitial(item)}
              </span>
            )}
            <span className="catalog-rail-item__label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default CatalogIconRail;
